import { FC, HTMLAttributes } from "react";
import {
  Typography,
  TypographyVariant,
  Header,
  Icon,
  useCustomNavigate,
} from "@onmo/ui";
import { useStyles } from "./ProfileHeader.style";
import Avatar from "../../core/Avatar/Avatar";
import { PageRoutes } from "../../../constants/routes";
import ShopIcon from "../../../assets/icons/shop-icon_1x.webp";
import ShopIcon2x from "../../../assets/icons/shop-icon_2x.webp";
import ShopIcon3x from "../../../assets/icons/shop-icon_3x.webp";
import { useTranslation } from "react-i18next";

interface IProfileHeader extends HTMLAttributes<HTMLDivElement> {
  avatar?: string;
  username?: string;
}

const ProfileHeader: FC<IProfileHeader> = (props) => {
  const classes = useStyles();
  const { t } = useTranslation();
  const { navigate, handleBack } = useCustomNavigate();

  const { avatar = "", username = "" } = props;

  return (
    <>
      <Header
        leftElement={
          <Icon name="icon-linear-arrow-left-3" onClick={() => handleBack()} />
        }
        title={t("profile")}
      />
      <div className={classes.profile}>
        <Avatar
          size="xl"
          url={avatar}
          icon={{ src1x: ShopIcon, src2x: ShopIcon2x, src3x: ShopIcon3x }}
          actionIcon={() => navigate(PageRoutes.Shop)}
          alt={`${avatar}`}
        />
        <div>
          <Typography
            className={classes.nickname}
            variant={TypographyVariant.HeadingH5Bold}
          >
            {username}
            <Icon
              name="icon-bold-edit-2"
              onClick={() => navigate(PageRoutes.EditProfile)}
            />
          </Typography>
        </div>
      </div>
    </>
  );
};
export default ProfileHeader;
